/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1ExamRevisionQuestionMutationRequest,
  PutApiV1ExamRevisionQuestionMutationResponse,
  PutApiV1ExamRevisionQuestion400,
  PutApiV1ExamRevisionQuestion401,
  PutApiV1ExamRevisionQuestion404,
  PutApiV1ExamRevisionQuestion500,
} from "../../types/examRevisionController/PutApiV1ExamRevisionQuestion.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1ExamRevisionQuestion } from "../../clients/examRevisionController/putApiV1ExamRevisionQuestion.ts";

export const putApiV1ExamRevisionQuestionMutationKey = () =>
  [{ url: "/api/v1/exam/revision/question" }] as const;

export type PutApiV1ExamRevisionQuestionMutationKey = ReturnType<
  typeof putApiV1ExamRevisionQuestionMutationKey
>;

export function putApiV1ExamRevisionQuestionMutationOptions<TContext = unknown>(
  config: Partial<
    RequestConfig<PutApiV1ExamRevisionQuestionMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = putApiV1ExamRevisionQuestionMutationKey();
  return mutationOptions<
    PutApiV1ExamRevisionQuestionMutationResponse,
    ResponseErrorConfig<
      | PutApiV1ExamRevisionQuestion400
      | PutApiV1ExamRevisionQuestion401
      | PutApiV1ExamRevisionQuestion404
      | PutApiV1ExamRevisionQuestion500
    >,
    { data?: PutApiV1ExamRevisionQuestionMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return putApiV1ExamRevisionQuestion(data, config);
    },
  });
}

/**
 * @description Cria ou atualiza uma questão de tradução com suas opções. Quando QuestionId for 0, cria uma nova questão vinculada ao idioma informado; caso contrário, atualiza a questão existente. Após salvar, recalcula automaticamente o status do idioma e da prova com base na situação de revisão das questões. **(Requer Authorization para autenticação)**
 * @summary Salvar questão de tradução da prova gerada por IA (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/question}
 */
export function usePutApiV1ExamRevisionQuestion<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1ExamRevisionQuestionMutationResponse,
      ResponseErrorConfig<
        | PutApiV1ExamRevisionQuestion400
        | PutApiV1ExamRevisionQuestion401
        | PutApiV1ExamRevisionQuestion404
        | PutApiV1ExamRevisionQuestion500
      >,
      { data?: PutApiV1ExamRevisionQuestionMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiV1ExamRevisionQuestionMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiV1ExamRevisionQuestionMutationKey();

  const baseOptions = putApiV1ExamRevisionQuestionMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1ExamRevisionQuestionMutationResponse,
    ResponseErrorConfig<
      | PutApiV1ExamRevisionQuestion400
      | PutApiV1ExamRevisionQuestion401
      | PutApiV1ExamRevisionQuestion404
      | PutApiV1ExamRevisionQuestion500
    >,
    { data?: PutApiV1ExamRevisionQuestionMutationRequest },
    TContext
  >;

  return useMutation<
    PutApiV1ExamRevisionQuestionMutationResponse,
    ResponseErrorConfig<
      | PutApiV1ExamRevisionQuestion400
      | PutApiV1ExamRevisionQuestion401
      | PutApiV1ExamRevisionQuestion404
      | PutApiV1ExamRevisionQuestion500
    >,
    { data?: PutApiV1ExamRevisionQuestionMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1ExamRevisionQuestionMutationResponse,
    ResponseErrorConfig<
      | PutApiV1ExamRevisionQuestion400
      | PutApiV1ExamRevisionQuestion401
      | PutApiV1ExamRevisionQuestion404
      | PutApiV1ExamRevisionQuestion500
    >,
    { data?: PutApiV1ExamRevisionQuestionMutationRequest },
    TContext
  >;
}
